interface PageTitleProps {
    title: string;
    description?: string;
    className?: string;
    titleSize?: string;
    descriptionSize?: string;
}

export const PageTitle = ({
    title,
    description,
    className = '',
    titleSize = '',
    descriptionSize = ''
}: PageTitleProps) => {
    return (
        <div className={`flex justify-between items-start w-full ${className}`}>
            <div>
                <h1 className={`text-2xl font-bold tracking-tight text-[#613F4F] ${titleSize}`}>
                    {title}
                </h1>
                {description && (
                    <p className={`text-muted-foreground ${descriptionSize}`}>{description}</p>
                )}
            </div>
        </div>
    );
};
